export const AppDashBloc:any=[
    {
        label:"Nombre utilisateurs",
        minLabel:"Nb. utilisateurs",
        key:"ALL-USERS"
    },
    {
        label:"Nombre Enseigants",
        minLabel:"Nb. Enseigants",
        key:"ALL-PROFESSORS"
    },
    {
        label:"Nombre Enseigants Maternelle",
        minLabel:"Nb. Enseigants Mat.",
        key:"PROFESSORS-MATERNELLE"
    },
    {
        label:"Nombre Enseigants Primaire",
        minLabel:"Nb. Enseigants Prim.",
        key:"PROFESSORS-PRIMAIRE"
    },
    {
        label:"Nombre Enseigants Collège&Lycée",
        minLabel:"Nb. Enseigants Collège&Lycée.",
        key:"PROFESSORS-CL"
    },
    {
        label:"Nombre de parent d'elève",
        minLabel:"Nb. Parent d'élève",
        key:"ALL-PARENTS"
    },
    {
        label:"Nombre Apprenants",
        minLabel:"Nb. Apprenants",
        key:"ALL-STUDENTS"
    },
    {
        label:"Nombre Apprenants Cycles(s)",
        minLabel:"Nb. Apprenants Cycle(s)",
        key:"APPRENANTS-GROUP"
    },
    {
        label:"Evolution des inscriptions",
        minLabel:"Ev. Ins. ",
        key:"GRAPH-INS"
    },
    {
        label:"Nombre de préoccupations",
        minLabel:"Nb. Préoccupations. ",
        key:"INQUERY"
    },
    {
        label:"Nombre de contrôle de soins",
        minLabel:"Nb. contrôles de soins. ",
        key:"HEALTH-CONTROL"
    },
]